/**
 * Normalize a genotype string to a consistent two-letter sorted form.
 *
 * Returns `--` for no-calls. For X-linked variants in males, single-letter
 * genotypes are preserved (hemizygous). Insertion/deletion markers (D/I)
 * are passed through unchanged.
 */
export const normalizeGenotype = ({
  genotype,
  isXLinked = false,
  isMale = false,
}: {
  genotype: string;
  isXLinked?: boolean;
  isMale?: boolean;
}): string => {
  if (!genotype || genotype === '--' || genotype === '00' || genotype === 'NC') {
    return '--';
  }

  let normalized = genotype.trim().toUpperCase().replace(/[/|\s]/g, '');

  if (normalized.includes('D') || normalized.includes('I')) {
    return normalized;
  }

  if (isXLinked && isMale && normalized.length === 1) {
    return normalized;
  }

  if (normalized.length === 1 && !isXLinked) {
    normalized = normalized + normalized;
  }

  if (normalized.length === 2) {
    normalized = normalized.split('').sort().join('');
  }

  if (normalized.length !== 2 && !(isXLinked && isMale && normalized.length === 1)) {
    return '--';
  }

  return normalized;
};
